/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:-webkit-sticky;position:sticky;top:0;z-index:4;box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12)}mat-toolbar[_ngcontent-%COMP%]{-ms-flex-pack:justify;justify-content:space-between}.logo[_ngcontent-%COMP%]{height:24px}.actions[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.actions[_ngcontent-%COMP%] > mat-icon[_ngcontent-%COMP%]:not(:last-child){margin-right:16px}"];
export { styles as styles };
